import { Typography } from '@mui/material';
import { PanelBase, PanelBaseType } from '@pages/NewQuote/PanelBase/PanelBase';
import { ITogglePanel } from '@pages/NewQuote/TogglePanel';
import { useNewQuoteStore } from '@store/NewQuote';
import { formatTwoLineAddress } from '@utils/address';

export const LocationClosedPanel = ({ onOpen }: ITogglePanel) => {
  const { location, scope } = useNewQuoteStore();
  const { isSpecialEvent } = scope;
  const { insuredLocation } = location;
  const twoLineAddress = formatTwoLineAddress(insuredLocation);

  return (
    <PanelBase
      name={isSpecialEvent ? 'Address of Event Venue' : 'Location'}
      type={PanelBaseType.Closed}
      onEdit={onOpen}
    >
      {twoLineAddress.map((address) => (
        <Typography
          key={address}
          variant='bodySmall'
          sx={{
            fontWeight: 'bold',
            display: 'block',
          }}
        >
          {address}
        </Typography>
      ))}
    </PanelBase>
  );
};
